import Dexie, { Table } from 'dexie'
import { EnrolledCourseType, LectureType } from 'types'

class AgilearnDB extends Dexie {
  enrolled!: Table<EnrolledCourseType, string>
  lectures!: Table<
    { courseRefPath: string; updatedAt?: string } & LectureType,
    string
  >

  constructor() {
    super('AgilearnDB')
    this.version(1).stores({
      enrolled: 'id',
      lectures: 'id'
    })
  }
}

export const agilearnDb = new AgilearnDB()
